import React, { useState } from 'react'
import PropagateLoader from "react-spinners/PropagateLoader";
import { useSelector } from 'react-redux';
import DataTables from '../LMS_DATA_TABLE/DataTable';

export default function QuizDetails(props) {

    const { detailModal, setDetailModal, modalLoading, setModalLoading } = props;

    const data = useSelector(state => state.quizDetails && state.quizDetails.data && state.quizDetails.data.data && state.quizDetails.data.data[0].lms_quiz_sub_schemas)
    const details = useSelector(state => state.quizDetails && state.quizDetails.data && state.quizDetails.data.data && state.quizDetails.data.data[0])
    // console.log(details)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: `QUESTION ID`,
            field: 'id',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            width: 100
        },
        {
            headerName: 'QUESTIONS',
            field: 'question',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REMARK',
            field: 'remark',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => <span className={params.value == 'active' ? 'badge text-bg-success' : 'badge text-bg-danger'} style={{ textTransform: 'capitalize' }}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ]);

    return (
        <>
            <div className={detailModal ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }}>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Quiz Details</h5>
                            <span className={details && details.status == 'active' ? 'badge text-bg-success ms-2' : 'badge text-bg-danger ms-2'}
                                style={{ textTransform: 'capitalize' }}>{modalLoading ? 'Loading...' : details && details.status}</span>
                            <button type="button" className="btn-close" style={{ boxShadow: 'none' }} onClick={() => { setDetailModal(false); setModalLoading(true) }}></button>
                        </div>

                        {modalLoading ?
                            <div className="modal-body">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="modal-body">
                                <div className='d-flex align-items-baseline'>
                                    <span style={{ color: '#9d9d9d' }}>Quiz Name:</span>
                                    <h6 className='ms-2'>{details && details.quiz_title}</h6>
                                </div>
                                <div className='d-flex align-items-baseline mb-2'>
                                    <span style={{ color: '#9d9d9d' }}>Created on:</span>
                                    <h6 className='ms-2'>{details && details.createdAt}</h6>
                                </div>

                                <DataTables
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    height='45vh'
                                />

                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
